import fetch from "logic/rest/FetchProvider";
import inputsUrl from "forwarder/forwarders/inputsUrl";
const fetchForwarderNode = (nodeId) => fetch(
  "GET",
  inputsUrl({
    segments: ["forwarders", "byNodeId", nodeId]
  })
).then((response) => response == null ? void 0 : response.forwarder);
export default fetchForwarderNode;
